export const auth = {
  ACCOUNT_CANNOT_BE_USED:'アカウント使えません',//已验证
  ACCOUNT_HAS_EXPIRE:'アカウントは既に有効期限を切れて、使えなくなっています',//需要等过期了才能验证
  USER_STATUS_IS_REQUIRED:'ユーザーステータスを入力してください',//应该不会出现
  EFFECTIVE_TIME_IS_REQUIRED:'発効日を入力してください',//已验证
  10003:'有効期限を入力してください',//已验证
  EFFECTIVE_TIME_MUST_BEFORE_EXPIRE_TIME:'発効日は有効期限を超えてはいけません。',//已验证
  EXPIRE_TIME_MUST_AFTER_NOW:'有効期限は本日以降の日付に設定してください。',//已验证
  USERNAME_REPEATED:'ユーザー名が重複になっています',//username不会重复，所以邮箱不会重复,不会出现
  EMAIL_REPEATED:'メールアドレスが重複になっています',//username不会重复，所以邮箱不会重复,不会出现
  ERROR_USER_OR_PASSWORD:'ユーザー名またはパスワードが間違っています',
  PHONE_USED:'携帯番号は既に登録されています',//应该不会出现（不传）
  PHONE_NOT_NULL:'携帯番号を入力してください',//应该不会出现（不传）
  ILLEGAL_PHONE_NUMBER_PATTERN:'携帯番号の入力方式が正しくありません',//应该不会出现（不传）
  ILLEGAL_PASSWORD_PATTERN:'パスワードの書式  最小12桁、最大20桁まで、少なくとも一つの大文字、小文字、数字と特殊記号を含む必要があります。',//已验证
  USER_REAL_NAME_NOT_NULL:'名前を入力してください',//已验证
  USER_REAL_NAME_FORMAT_INVALID:'名前の書式は正しくありません（書式：漢字、英語とスペース、頭文字は漢字と英語しか使えなく、長さは50文字を超えてはいけません）',//已验证
  USER_NAME_NOT_NULL:'ユーザー名を入力してください',//不会出现空的
  USER_NAME_FORMAT_INVALID:'ユーザー名の書式は正しくありません（書式：英語、数字、スラッシュ“/”、アンダーバー”_”、セミコロン”.，”、長さは64桁を超えてはいけません、メールアドレスの書式も利用可能です）',//不会出现空的
  USER_LANGUAGE_NOT_NULL:'言語を選んでください',//不会出现
  USER_SAME_PASSWORD_RESET_EXCEPTION:'新パスワードは旧パスワードと重複してはいけません。',//已验证
  USER_EMAIL_IS_NULL:'ユーザーメールアドレスを入力してください',//不会出现空的
  ILLEGAL_EMAIL_PATTERN:'メールアドレスの入力方式が正しくありません',//不会出现，格式默认固定的
  OTHER:'その他エラー',//已验证
  USERNAME_CREDENTIAL_ERROR:'アカウントとパスワードが間違っています。',
  NO_IDENTITY_LIST:'該当ユーザーはシステムにログインできません。',
  ACCOUNT_NOT_EXIST:'ユーザーが見つかりませんでした。'
}